// Shared camera stream: kept alive for a while after the scanner closes so the
// browser (especially iOS Safari / home-screen apps) doesn't re-prompt for permission.
let stream = null;
let releaseTimer = null;
const KEEP_ALIVE_MS = 10 * 60 * 1000;

const CONSTRAINTS = { video: { facingMode: { ideal: "environment" }, width: { ideal: 4096 }, height: { ideal: 3072 } }, audio: false };

const isLive = (s) => s && s.getVideoTracks().some((t) => t.readyState === "live");

export async function getCameraStream() {
  clearTimeout(releaseTimer);
  if (isLive(stream) && !stream.getVideoTracks()[0].muted) {
    stream.getVideoTracks().forEach((t) => { t.enabled = true; });
    return stream;
  }
  stopCameraStream();
  stream = await navigator.mediaDevices.getUserMedia(CONSTRAINTS);
  const track = stream.getVideoTracks()[0];
  try { await track.applyConstraints({ advanced: [{ focusMode: "continuous" }] }); } catch { /* unsupported */ }
  return stream;
}

export function releaseCameraStream() {
  if (!stream) return;
  stream.getVideoTracks().forEach((t) => { t.enabled = false; });
  clearTimeout(releaseTimer);
  releaseTimer = setTimeout(stopCameraStream, KEEP_ALIVE_MS);
}

export function stopCameraStream() {
  clearTimeout(releaseTimer);
  stream?.getTracks().forEach((t) => t.stop());
  stream = null;
}

export async function cameraPermissionState() {
  try {
    const p = await navigator.permissions.query({ name: "camera" });
    return p.state; // granted | denied | prompt
  } catch {
    return "unknown";
  }
}

// Resolves true once the video element actually renders a frame from the stream.
export function waitForFrames(video, timeoutMs = 2000) {
  return new Promise((resolve) => {
    let done = false;
    const finish = (ok) => { if (!done) { done = true; resolve(ok); } };
    const timer = setTimeout(() => finish(false), timeoutMs);
    if (video.requestVideoFrameCallback) {
      video.requestVideoFrameCallback(() => { clearTimeout(timer); finish(true); });
    } else {
      const poll = () => {
        if (done) return;
        if (video.readyState >= 3 && video.videoWidth > 0) { clearTimeout(timer); finish(true); } else setTimeout(poll, 100);
      };
      poll();
    }
  });
}

if (typeof window !== "undefined") window.addEventListener("pagehide", stopCameraStream);
